import React from 'react';
import { Text } from '@chakra-ui/react';
import { FEATURES } from '../config';
import ExportProfileAction, { getVisibleActionError } from './ExportProfileAction';
import SharingLinkControls from './SharingLinkControls';

// Admin actions for a person row in the People list: Export Profile (behind its feature
// flag), the sharing page controls, and any profile generation or export error.
// The HoggedIn page arranges the same pieces itself in AdminToolbar.
const AdminProfileActions = ({
  person,
  exportLinks = {},
  onExportProfile,
  exporting = {},
  actionErrors = {},
  isVisible = true,
  exportEnabled = FEATURES.exportProfile
}) => {
  const personId = person?.personid;
  if (!isVisible || !personId || person?.description == null) {
    return null;
  }

  const actionError = getVisibleActionError(actionErrors, personId, exportEnabled);

  return (
    <>
      <ExportProfileAction
        personId={personId}
        exportLinks={exportLinks}
        exporting={exporting}
        onExportProfile={onExportProfile}
        exportEnabled={exportEnabled}
      />
      <SharingLinkControls sharingToken={person?.sharing_link?.token ?? null} />
      {actionError && (
        <Text fontSize="sm" color="red.500">
          {actionError}
        </Text>
      )}
    </>
  );
};

export default AdminProfileActions;
